module.exports = __webpack_public_path__ + "static/img/flowered-1.d5af370.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/flowered-1.jpg
// module id = u3Ev
// module chunks = 1